/* eslint-disable jsx-a11y/anchor-is-valid */
import React ,{useEffect,useState}from "react";
import axios from "axios";
import { NODE_API_URL,BASE_URL } from "../../../env_config";
import {FeedRequest,IFrameRequested,IFrameRejected,IFrameSuspended} from "./"
import {RulePage} from "./RulePage";
import { IframeSetupNew } from "./IframeSetupNew";
import Cookies from "js-cookie";
import { CongratulateShopifyDashboardPopUp } from "../Popup/CongratulateShopifyDashboardPopUp";
import ShopifyAppInstallForm from "../shopify/ShopifyAppInstallForm";
import { ShopifyRulePage } from "../shopify/ShopifyRulePage";
import { CongratulateWooCommerceDashboardPopUp } from "../Popup/CongratulateWooCommerceDashboardPopUp";
import WooCommerceInstallForm from "../WooCommerce/WooCommerceInstallForm";
import { WooCommerceRulePage } from "../WooCommerce/WooCommerceRulePage";
import CompleteProfileFeedPopUp from "../Popup/CompleteProfileFeedPopUp";
import { CongratulateIframeDashboardPopUp } from "../Popup/CongratulateIframeDashboardPopUp";
import { CongratulateApiDashboardPopUp } from "../Popup/CongratulateApiDashboardPopUp";
import { Alert } from "react-bootstrap";

export const DiamondFeed = (props) => {
    
    const [updatedata,setUpdateData] = useState(false)
    const [customeriframeorapi,setCustomerIframeorAPI] = useState()
    const [customerapi,setCustomerAPI] = useState([])
    const [loader,setLoader] = useState(false)
    const [feedLoader,setFeedLoader] = useState(true)
    const [iframerules,setIframeRules] = useState([])
    const [updaterule,setUpdateRules] = useState(false)
    const [congratulatePopUp, setCongratulatePopUp] = useState(false);
    const [showfeed,setShowFeed] = useState(true)
    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/getKycMessage`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then((res) => {
            if (res && res?.data  && res?.data?.kycmessage && res?.data?.kycmessage?.kyc_status) {
                if(!res?.data?.showprice){
                  setShowFeed(false)
                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[])
    useEffect(() => {
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-iframeorapi`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then(supreq => {
            setFeedLoader(false)
            if(supreq && supreq.data && supreq.data.data){
                // setFeedLoader(false)
                setCustomerIframeorAPI(supreq.data.data)
                if(supreq.data.data?.shopify_access_token){
                  setCongratulatePopUp(!supreq.data.data.has_seen_dashboard_popup)
                } 
                if(supreq.data.data?.wordpress_site_url){
                  setCongratulatePopUp(!supreq.data.data.has_seen_dashboard_popup)
                }
                if(supreq.data.data.api === 1 && supreq.data.data.feed_request === 1){
                  setCongratulatePopUp(!supreq.data.data.has_seen_dashboard_popup)
                }
            }
        }).catch(error => {
            setFeedLoader(false)
            setLoader(false)
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
        setLoader(true)
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-Rules`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then(apireq => {
            setLoader(false)
            if(apireq && apireq.data && apireq.data.data && apireq.data.data.length){
                // console.log(apireq.data.data,"APIIIIIII")
                setFeedLoader(false)
                setCustomerAPI(apireq.data.data)
            }
            else{
                setCustomerAPI([])
            }
        }).
        catch(error => {
            setFeedLoader(false)
            setLoader(false)
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-iframe-rules`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then(iframereq => {
            setLoader(false)
            if(iframereq && iframereq.data && iframereq.data.data && iframereq.data.data.length){
                setIframeRules(iframereq.data.data)
            }
            else{
                setIframeRules([])
            }
        }).
        catch(error => {
            setFeedLoader(false)
            setLoader(false)
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[updatedata,updaterule])
    return (
        <>
            {showfeed?<div className="card custom-card border-0 feed-theme" id="API-request-page">
               { feedLoader ? 
                    <div className="card-body text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                    </div>
               :
                    <>
                    {customeriframeorapi?.feed_request === 1 && customeriframeorapi?.shopify_shop && customeriframeorapi.api_live_mode === 0 && customeriframeorapi.api_test_mode !== "ON" ? 
                    <Alert variant="warning">
                        Your Shopify diamond app is currently in testing. To start testing activate test mode. To activate Live Mode, please contact your account executive.
                    </Alert> : ""}
                    {customeriframeorapi?.feed_request === 1 && customeriframeorapi?.shopify_shop && customeriframeorapi.api_live_mode === 0 && customeriframeorapi.api_test_mode === "ON" ? 
                    <Alert variant="warning">
                        To activate Live Mode, please contact your account executive.
                    </Alert> : ""}

                    {customeriframeorapi?.feed_request === 1 && customeriframeorapi?.wordpress_site_url && customeriframeorapi.api_live_mode === 0 && customeriframeorapi.api_test_mode !== "ON" ? 
                    <Alert variant="warning">
                        Your WooCommerce Diamond plugin is currently in testing. To start testing activate test mode. To activate Live Mode, please contact your account executive.
                    </Alert> : ""}
                    {customeriframeorapi?.feed_request === 1 && customeriframeorapi?.wordpress_site_url && customeriframeorapi.api_live_mode === 0 && customeriframeorapi.api_test_mode === "ON" ? 
                    <Alert variant="warning">
                        To activate Live Mode, please contact your account executive.
                    </Alert> : ""}
                        <div className={`card-body ${customeriframeorapi?.shopify_shop || customeriframeorapi?.wordpress_site_url ||(customeriframeorapi?.feed_type === "API" || customeriframeorapi?.feed_type === "IFrame Plug-in") ? "bg-white rounded" : ""}`}> 
                            {customeriframeorapi ?
                                <div className={`${customeriframeorapi.feed_type === "API" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 ? "p-0" : ""}`}>
                                    <>
                                    {customeriframeorapi.feed_request === 3?<IFrameRequested feed_type={customeriframeorapi.feed_type} language={props.language}/>:""}
                                    {customeriframeorapi.feed_request === 2?<IFrameRejected feed_type={customeriframeorapi.feed_type} language={props.language}/>:""}
                                    {customeriframeorapi.feed_request === 1 && customeriframeorapi.api !== 1?<IFrameSuspended feed_type={customeriframeorapi.feed_type} language={props.language}/>:""}
                                    {customeriframeorapi.feed_type === "IFrame Plug-in" && customeriframeorapi.feed_request === 1 && customeriframeorapi.api === 1 && customeriframeorapi.feed_updated === 0?<IframeSetupNew {...props} language={props.language}/>:""}
                                    
                                    {customeriframeorapi.feed_type === "IFrame Plug-in" ? <CongratulateIframeDashboardPopUp show={congratulatePopUp} setShow={setCongratulatePopUp} userinfo={props.userinfo} language={props.language} /> :""}
                                    {customeriframeorapi.feed_type === "IFrame Plug-in" && customeriframeorapi.feed_request === 1 && customeriframeorapi.api === 1 && customeriframeorapi.feed_updated === 1?<RulePage {...props} customerapi={customerapi} setUpdateData={setUpdateData} updatedata={updatedata} loader={loader} setCustomerAPI={setCustomerAPI} customeriframeorapi={customeriframeorapi}/>:""}

                                    {customeriframeorapi.feed_type === "API" ? <CongratulateApiDashboardPopUp show={congratulatePopUp} setShow={setCongratulatePopUp} userinfo={props.userinfo} language={props.language} /> :""}
                                    {customeriframeorapi.feed_type === "API" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1?<RulePage {...props} customerapi={customerapi} setUpdateData={setUpdateData} updatedata={updatedata} loader={loader} setCustomerAPI={setCustomerAPI} customeriframeorapi={customeriframeorapi}/>:""}

                                    {/* shopify screen */}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP" ? <CongratulateShopifyDashboardPopUp feedType={customeriframeorapi.feed_type} show={congratulatePopUp} setShow={setCongratulatePopUp} userinfo={props.userinfo} language={props.language} /> :""}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && !customeriframeorapi?.shopify_shop? 
                                      <ShopifyAppInstallForm language={props.language} feedsetting={customeriframeorapi} setup={true} />
                                    : ""}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && customeriframeorapi?.shopify_shop ? <ShopifyRulePage {...props} customerapi={customerapi} setUpdateData={setUpdateData} updatedata={updatedata} loader={loader} setCustomerAPI={setCustomerAPI} customeriframeorapi={customeriframeorapi}/>:""}

                                    {/* shopify ring screen */}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP RING" ? <CongratulateShopifyDashboardPopUp feedType={customeriframeorapi.feed_type} show={congratulatePopUp} setShow={setCongratulatePopUp} userinfo={props.userinfo} language={props.language} /> :""}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP RING" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && !customeriframeorapi?.shopify_shop? 
                                      <ShopifyAppInstallForm language={props.language} feedsetting={customeriframeorapi} setup={true} />
                                    : ""}
                                    {customeriframeorapi.feed_type === "SHOPIFY APP RING" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && customeriframeorapi?.shopify_shop ? <ShopifyRulePage {...props} customerapi={customerapi} setUpdateData={setUpdateData} updatedata={updatedata} loader={loader} setCustomerAPI={setCustomerAPI} customeriframeorapi={customeriframeorapi}/>:""}

                                    {/* woocommerce screen */}
                                    {customeriframeorapi.feed_type === "WOOCOMMERCE PLUGIN" ? <CongratulateWooCommerceDashboardPopUp show={congratulatePopUp} setShow={setCongratulatePopUp} userinfo={props.userinfo} language={props.language} /> : ""}
                                    {customeriframeorapi.feed_type === "WOOCOMMERCE PLUGIN" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && !customeriframeorapi?.wordpress_site_url? 
                                      <WooCommerceInstallForm language={props.language} feedsetting={customeriframeorapi} setUpdateData={setUpdateData} />
                                    : ""}
                                    {customeriframeorapi.feed_type === "WOOCOMMERCE PLUGIN" && customeriframeorapi.api === 1 && customeriframeorapi.feed_request === 1 && customeriframeorapi?.wordpress_site_url ? <WooCommerceRulePage {...props} customerapi={customerapi} setUpdateData={setUpdateData} updatedata={updatedata} loader={loader} setCustomerAPI={setCustomerAPI} customeriframeorapi={customeriframeorapi}/>:""}
                                    </>
                                </div>
                            : <FeedRequest userinfo={props.userinfo} language={props.language}/> }
                        </div>
                </>
               }
            </div >:<CompleteProfileFeedPopUp/>}
        </>
    );
};
